
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AnnouncementFeed from './AnnouncementFeed';
import MembersList from './MembersList';

interface LGATabsProps {
  state: string;
  lga: string;
  isAdmin: boolean;
}

const LGATabs = ({ state, lga, isAdmin }: LGATabsProps) => {
  return (
    <Tabs defaultValue="announcements" className="w-full">
      <TabsList className="w-full mb-2 h-7">
        <TabsTrigger value="announcements" className="text-xs h-6">Announcements</TabsTrigger>
        <TabsTrigger value="members" className="text-xs h-6">Members</TabsTrigger>
      </TabsList>
      
      <TabsContent value="announcements">
        <AnnouncementFeed state={state} lga={lga} isAdmin={isAdmin} />
      </TabsContent>
      
      <TabsContent value="members">
        <MembersList state={state} lga={lga} isAdmin={isAdmin} />
      </TabsContent>
    </Tabs>
  );
};

export default LGATabs;
